import * as constant from "./constant";

const INITIAL_STATE = {
  loading: false,
  profile: {
    data: null,
    httpStatus: 0,
  },
  profileResponse: {
    data: null,
    httpStatus: 0,
  },
  deleteAccountResponse: {
    data: null,
    httpStatus: 0,
  },
};

const profileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constant.LOADING:
      return Object.assign({}, state, {
        loading: action.payload,
      });
    case constant.PROFILE:
      return Object.assign({}, state, {
        profile: action.payload,
      });
    case constant.PROFILE_RESPONSE:
      return Object.assign({}, state, {
        profileResponse: action.payload,
      });
    case constant.DELETE_ACCOUNT_RESPONSE:
      return Object.assign({}, state, {
        deleteAccountResponse: action.payload,
      });
    default:
      return state;
  }
};

export default profileReducer;
